const config = window.envConfig;

export default config;